
import { supabase } from "@/integrations/supabase/client";
import { NotificationPreferences } from "@/types/notifications";
import { DEFAULT_PREFERENCES } from "@/constants/notifications";

export const createDefaultPreferences = async (userId: string) => {
  try {
    const { data: newPrefs, error: insertError } = await supabase
      .from("notification_preferences")
      .insert({ 
        user_id: userId, 
        ...DEFAULT_PREFERENCES,
        account_notifications: true,
        system_notifications: true
      })
      .select()
      .single();
      
    if (insertError) {
      console.error("Error creating default preferences:", insertError);
      throw insertError;
    }
    
    console.log("Created default preferences:", newPrefs);
    return newPrefs;
  } catch (err) {
    console.error("Failed to create default preferences:", err);
    return { 
      user_id: userId, 
      ...DEFAULT_PREFERENCES,
      account_notifications: true,
      system_notifications: true
    };
  }
};
